import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EndConversationFormComponent } from './end-conversation-form/end-conversation-form.component';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxMaskModule } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    EndConversationFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    SharedModule,
    NgxMaskModule,
    ReactiveFormsModule
  ]
})
export class EndConversationModule { }
